import script from "./MaintenanceBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./MaintenanceBanner.vue?vue&type=script&setup=true&lang=js"

import "./MaintenanceBanner.vue?vue&type=style&index=0&id=163bc264&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-163bc264"]])

export default __exports__